import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { quickActionsSliceInitialState } from "./intialState";

const quickActionsSlice = createSlice({
  name: "quickActions",
  initialState: () => {
    const initialState = { 
      ...quickActionsSliceInitialState,
      isLoginSuccess:false
};
    return initialState;
  },
  reducers: {
    setAlertCount(state, action: PayloadAction<number>) {
      state.alertCount = action.payload;
      return state;
    },
    setCommunicationsCount(state, action: PayloadAction<number>) {
      state.communicationsCount = action.payload;
      return state;
    },
    setDownloadsCount(state, action: PayloadAction<number>) {
      state.downloadsCount = action.payload;
      return state;
    },
    setDownloadsData(state, action: PayloadAction<any>) {
      state.downloadsData = action.payload;
      return state;
    },
    setCommunicationsData(state, action: PayloadAction<any>) {
      state.communicationsData = action.payload;
      return state;
    },
    setAlertsData(state, action: PayloadAction<any>) {
      state.alertsData = action.payload;
      return state;
    },
    setIsLoginSuccess(state, action: PayloadAction<boolean>) {
      state.isLoginSuccess = action.payload;
      return state;
    }
  },
});

export const {
  setAlertCount,
  setCommunicationsCount,
  setDownloadsCount,
  setDownloadsData,
  setCommunicationsData,
  setAlertsData,
  setIsLoginSuccess
} = quickActionsSlice.actions;

export default quickActionsSlice;
